export default __webpack_public_path__ + "static/media/Contacts.cdef06a1.svg";